export enum Timer {
  SECONS_120 = 120000,
  INERTVAL_1000 = 1000,
  SECS_120 = 120,
}
